import { RootState } from 'types/RootState.types';

export default function shouldSaveDefaultCollectionPoint(state: RootState) {
  const {
    user: {
      collectionPoints = [],
      isSignedIn,
    } = {},
  } = state;

  if (!isSignedIn) return false;

  const defaultCollectionPoint = collectionPoints.find(point => point.isDefault);

  return !defaultCollectionPoint || !defaultCollectionPoint.isAvailable;
}
